<!--
/**
* @name: List.vue
* @description: 交易管理-下单规则设置列表页面
* @author: 杨波
* @create: 2020/08/17 14:06:58
* @update: 2020/08/17 14:06:58
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input placeholder="请输入规则名称" clearable v-model="para.nameLike"></k-input>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAddRule">新建规则</y-button>
      </y-query-item>
    </y-query>
    <k-table :data="ruleList" has-index :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>

<script>
import { NESTLE_TRADE_BACK_SERVER_ORDER_RULE_PAGE, NESTLE_TRADE_BACK_SERVER_ORDER_RULE_DELETE, NESTLE_TRADE_BACK_SERVER_ORDER_RULE_TOGGLE_DISABLED } from "@/assets/modules/apiList";
const initPara = () => ({
  nameLike: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      ruleList: [],
      para: initPara(),
      total: 20,
      isLoading: false,
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "规则名称",
          field: "name",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "销售渠道",
          field: "",
          style: {
            width: 180,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = [];
            for (let i = 0; i < row.saleChannelList.length; i++) {
              temp.push(row.saleChannelList[i].saleChannelName);
            }
            const valueStr = <span>{temp.join(",")}</span>;
            return <div>{valueStr}</div>;
          },
        },
        {
          name: "贸易类型",
          field: "",
          style: {
            width: 180,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = [];
            for (let i = 0; i < row.tradeModeList.length; i++) {
              temp.push(row.tradeModeList[i].name);
            }
            const valueStr = <span>{temp.join(",")}</span>;
            return <div>{valueStr}</div>;
          },
        },
        {
          name: "规则描述",
          field: "errorMessage",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "创建时间",
          field: "createTime",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "启停用状态",
          field: "",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={!row.isDisabled}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "操作",
          field: "action",
          style: {
            textAlign: "center",
          },
          customRender: (row) => {
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEditRule(row);
                }}
              >
                编辑
              </a>
            );
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDelete(row);
                }}
              >
                删除
              </a>
            );
            return (
              <div>
                {editButton}&#12288;{deleteButton}
              </div>
            );
          },
        },
      ];
    },
    onAddRule() {
      this.$controller.open({
        name: "placeOrderAdd",
        query: {
          refresh: new Date() - 0,
        },
      });
    },
    onEditRule(row) {
      this.$controller.open({
        name: "placeOrderAdd",
        query: {
          refresh: new Date() - 0,
          id: row.id,
          edit: 1,
        },
        title: "编辑下单规则",
      });
    },
    onDelete(row) {
      let { id } = row;
      this.$dialog({
        title: "提示",
        content: "规则删除后，所有关于此规则的校验条件将失效确认删除此规则吗？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_TRADE_BACK_SERVER_ORDER_RULE_DELETE,
            para: { id },
          })
            .then(() => {
              this.isLoading = false;
              this.getRuleList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getRuleList();
    },
    onReset() {
      this.para = initPara();
      this.getRuleList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getRuleList();
    },
    onChangeStatus(row) {
      let { id } = row;
      this.$dialog({
        title: "提示",
        content: "是否确认切换当前启停用状态？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_TRADE_BACK_SERVER_ORDER_RULE_TOGGLE_DISABLED,
            para: { id },
          })
            .then(() => {
              this.isLoading = false;
              this.getRuleList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    getRuleList() {
      let { para } = this;
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_ORDER_RULE_PAGE,
        para,
      })
        .then((res) => {
          this.ruleList = res.pageList;
          this.total = res.total;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getRuleList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getRuleList();
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
